<script setup lang="ts">
import { onMounted } from "vue";
import { usePaymentStore } from "@/stores/payment";

const paymentStore = usePaymentStore();

onMounted(() => {
    paymentStore.initialiseStripe();
});
</script>

<template>
    <RouterView></RouterView>
</template>
